import {
    Box, PopoverArrow, PopoverBody, Text, VStack, UnorderedList, ListItem,
} from '@chakra-ui/react';

export function ActionsRequiredPopoverContent() {
    return (
        <>
            <PopoverArrow />
            <PopoverBody fontSize="sm">
                <VStack gap={2} align="start">
                    <Box>
                        <Text fontWeight="bold">Action Required</Text>
                        <Text color="muted.700">
                            Urgent and non-urgent &apos;Actions required&apos; for
                            properties enrolled to receive one or more services from Detector
                            Inspector.
                        </Text>
                    </Box>

                    <Box>
                        <Text fontWeight="bold">Access issues</Text>
                        <Text color="muted.700">
                            Shows the number of properties where we are having problems booking
                            or completing a service and require your help to overcome
                            those problems.
                        </Text>
                        <Text color="muted.700" mt={2}>
                            The issue is defined as &apos;urgent&apos; where the due date has passed
                            and therefore the service is overdue.
                        </Text>
                    </Box>

                    <Box>
                        <Text fontWeight="bold">Reported findings</Text>
                        <Text color="muted.700">
                            Number of services with Reported Findings identified during
                            a safety check that require further action.
                        </Text>
                        <UnorderedList color="muted.700">
                            <ListItem>
                                <Text as="span" fontWeight="bold">Urgent</Text>
                                : Issues that impact
                                compliance and require immediate attention.
                            </ListItem>
                            <ListItem>
                                <Text as="span" fontWeight="bold">Non-urgent</Text>
                                : Findings that do not
                                affect compliance but are recommended to be addressed.
                            </ListItem>
                        </UnorderedList>
                        <Text color="muted.700" mt={2}>
                            * This view does not include properties where there is a Booking
                            in Progress or accepted quote for the finding
                        </Text>
                    </Box>

                    <Box>
                        <Text fontWeight="bold">Invoices</Text>
                        <Text color="muted.700">
                            Shows the number of invoices that have been issued and are unpaid. The
                            issue is defined as &apos;urgent&apos; where the invoice and property
                            is overdue.
                        </Text>
                    </Box>

                    <Box>
                        <Text fontWeight="bold">New management</Text>
                        <Text color="muted.700">
                            Shows the number of properties that have been identified as new
                            managements via API integration with your property management software
                            in the past 30 days.
                        </Text>
                    </Box>
                </VStack>
            </PopoverBody>
        </>
    );
}
